<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Login from "./components/Login.vue";

export default {
  name: "app",
  components: {
    Login
  },
  mounted() {
    document.title = this.$route.meta.title;
  },
  watch: {
    $route(to, from) {
      document.title = to.meta.title || "One ID";
    }
  }
};
</script>

<style>
body {
  background-color: #f2f4f8;
  font-family: "Roboto", sans-serif;
}
</style>
